import styled from 'styled-components';
import { ShadowBox, Expander as VendorExpander } from 'app/components';
import { textTransform } from 'utils';


export const TechnologyList = styled.div.attrs({
  className: 'technology-list'
})`
  display: flex;
  justify-content: center;

  .technology-list__wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 26px;
    grid-row-gap: 31px;

    .technology-list__item {
      .technology-list__item-image {
        height: 171px;
        width: 304px;
      }
      .technology-list__item-content {
        background: #2d2d2d;
        padding: 5px 10px 10px 10px;

        h2 {
          font-weight: 450;
          font-size: 20px;
          line-height: 22px;
          letter-spacing: 1.5px;
          text-transform: ${textTransform};
        }

        h3 {
          font-weight: 390;
          font-size: 16px;
          line-height: 24px;
          color: #979797;
          margin-top: 4px;
          max-width: 282px;
        }
      }
    }
    @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
      grid-template-columns: repeat(1, 1fr);
      width: 100%;
      .technology-list__item {
        .technology-list__item-image {
          height: auto;
          width: auto;
        }
      }
    }
  }
`;

export const SectionTop = styled.div`
  // width: 100%;
  // margin: 30px auto;
  // max-width: 80%;
  

  li{
    display: list-item;
    list-style: inherit;
  }
  ul {
    margin-left:43px;
  }
  a{
    text-decoration: underline;
    color:#DE1619;
  }
  // @media (max-width: 768px) {
  //   max-width: 86%;
  // }
`;

export const H2Div = styled.div`
  font-style: normal;
  font-weight: 450;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 3px;
  text-transform: ${textTransform};
  color: #ffffff;
  margin-bottom: 15px;
`;

export const PDiv = styled.div`
  font-style: normal;
  font-weight: 100;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  letter-spacing: 1px;
  margin: 30px 0px;
  border-bottom: 1px solid #323232;
  padding-bottom: 30px;
  margin-bottom: 0px;
  span {
    color: #de1619;
  }
`;

export const General = styled.div`
  div.l-faq__item-title {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 10px 16px;
    font-size: 16px;
    line-height: 1.1;
    color: #fff;
    border-bottom: 1px solid #323232;
  }
  div.accordion__panel {
    padding: 14px 32px;
    line-height: 1.5;
    color: #fff;
    background-color: #2d2d2d;
  }
  .accordion__button:before {
    position: absolute;
    right: 0%;
    transform: rotate(45deg);
  }
  .accordion__button[aria-expanded='true']::before,
  .accordion__button[aria-selected='true']::before {
    transform: rotate(225deg);
  }
  .accordion__heading {
    position: relative;
  }
  .accordion__item {
    border-bottom: 1px solid #2d2d2d;
  }
  .accordion__button {
    color: #fff;
    background: rgba(255, 255, 255, 0.0001);
  }
  .accordion__button:hover {
    background-color: rgba(255, 255, 255, 0.0001);
  }
  .accordion {
    border: none;
  }
  .bonus-card-info__faq-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-top: 1px solid #323232;
    padding: 10px 16px;
  }
  .bonus-card-info__faq-item h3 {
    font-weight: 390;
    font-size: 18px;
    line-height: 20px;
    margin: 0;
  }
`;
export const GetInTouch = styled.div`
  margin: 50px 0px;
  .mb-3 {
    margin-bottom: 30px;
  }
  h4 {
    font-size: 18px;
    font-weight: 100;
  }
  button.get_in_touch {
    background: #de1619;
    box-shadow: 0px 3px 16px rgb(222 22 25 / 50%);
    border-radius: 36px;
    padding: 15px 50px;
    color: #fff;
    // margin: 30px 0px;
    font-size: 16px;
  }
  a {
    color: #de1619;
  }
`;
export const GetInTouchForm = styled.div`
  margin: 50px 0px;
  border-top: 3px solid #979797;
  padding-top: 40px;
  button.get_in_touch {
    background: #de1619;
    box-shadow: 0px 3px 16px rgb(222 22 25 / 50%);
    border-radius: 36px;
    padding: 15px 50px;
    color: #fff;
    margin: 30px 0px;
    font-size: 16px;
  }
  hr {
    border-color: #979797;
  }
  .privacy_policy{
    margin-top: 30px;
  }
`;
export const GetInForm = styled(ShadowBox).attrs({
  className: 'f-sign-up'
})`
  form.form_get_in {
    margin-top: 25px;
  }
`;

export const OnlyForm = styled.div`
  max-width: 70%;
  p.label_require {
    margin-top: 20px;
  }
  h3 {
    font-weight: 390;
    font-size: 16px;
    line-height: 24px;
    color: #888888;
    display: inline;
    margin-left: 10px;
  }
  span.attachment {
    font-style: italic;
    font-weight: 330;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    display: block;
    margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    textarea#message {
      width: 100%;
    }
  }
`;
export const RadioButtonSection = styled.div`
  h3 {
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 1.5px;
    color: #ffffff;
    margin-top: 20px;
  }
`;

export const Ul = styled.div`
  margin: 30px 0px;
  label.cinema-rent__hall-radio {
    padding: 0px;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
  }
  span.f-default__radio-btn {
    margin-right: 10px;
  }
`;

export const LI = styled.div`
  margin: 15px 0px;
`;

export const Expander = styled(VendorExpander)`
  background: #2d2d2d;
  padding: 0 16px;

  .bonus-card-info__faq-item-expand-content {
    margin: 16px 0;
  }
`;


export default TechnologyList;
